/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDomainsBlocklistRecord } from './CRSFSecReviewDomainsBlocklistRecord';
import {
    CRSFSecReviewDomainsBlocklistRecordFromJSON,
    CRSFSecReviewDomainsBlocklistRecordFromJSONTyped,
    CRSFSecReviewDomainsBlocklistRecordToJSON,
} from './CRSFSecReviewDomainsBlocklistRecord';

/**
 * 
 * @export
 * @interface CRSFSecReviewDomainsBlocklist
 */
export interface CRSFSecReviewDomainsBlocklist {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsBlocklist
     */
    assets: number;
    /**
     * 
     * @type {Array<CRSFSecReviewDomainsBlocklistRecord>}
     * @memberof CRSFSecReviewDomainsBlocklist
     */
    results: Array<CRSFSecReviewDomainsBlocklistRecord>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsBlocklist
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainsBlocklist interface.
 */
export function instanceOfCRSFSecReviewDomainsBlocklist(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFSecReviewDomainsBlocklistFromJSON(json: any): CRSFSecReviewDomainsBlocklist {
    return CRSFSecReviewDomainsBlocklistFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainsBlocklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainsBlocklist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': json['assets'],
        'results': ((json['results'] as Array<any>).map(CRSFSecReviewDomainsBlocklistRecordFromJSON)),
        'total': json['total'],
    };
}

export function CRSFSecReviewDomainsBlocklistToJSON(value?: CRSFSecReviewDomainsBlocklist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
        'results': ((value.results as Array<any>).map(CRSFSecReviewDomainsBlocklistRecordToJSON)),
        'total': value.total,
    };
}

